"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useCreditStore } from "@/stores/useCreditStore";
export function OutOfCreditsDialog() {
  const $ = _c(13);
  const router = useRouter();
  const outOfCreditsModalOpen = useCreditStore(_temp);
  const closeOutOfCreditsModal = useCreditStore(_temp2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DialogHeader><DialogTitle>Out of innovation credits</DialogTitle><DialogDescription>You have no remaining credits for AI generation. Upgrade or top up your plan to continue creating conversations and learnings.</DialogDescription></DialogHeader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== closeOutOfCreditsModal) {
    t1 = <Button variant="outline" onClick={closeOutOfCreditsModal}>Close</Button>;
    $[1] = closeOutOfCreditsModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== closeOutOfCreditsModal || $[4] !== router) {
    t2 = <Button onClick={() => {
      closeOutOfCreditsModal();
      router.push("/dashboard/billing");
    }}>Manage plan</Button>;
    $[3] = closeOutOfCreditsModal;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <DialogContent>{t0}<DialogFooter>{t1}{t2}</DialogFooter></DialogContent>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== closeOutOfCreditsModal || $[10] !== outOfCreditsModalOpen || $[11] !== t3) {
    t4 = <Dialog open={outOfCreditsModalOpen} onOpenChange={closeOutOfCreditsModal}>{t3}</Dialog>;
    $[9] = closeOutOfCreditsModal;
    $[10] = outOfCreditsModalOpen;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp2(s_0) {
  return s_0.closeOutOfCreditsModal;
}
function _temp(s) {
  return s.outOfCreditsModalOpen;
}